import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRightSlideshowArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 7,
	height: 11,
	viewBox: "0 0 7 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M1.31242 -4.1008e-05L6.33325 5.02079L1.31242 10.0416L0.416585 9.14579L4.54159 5.02079L0.416585 0.895792L1.31242 -4.1008e-05Z" })
});
export default SvgRightSlideshowArrow;
